/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Created_WarningInputs */

const en_settings_apikeys_created_warning = /** @type {(inputs: Settings_Apikeys_Created_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy your key now, it won't be shown again.`)
};

/**
* | output |
* | --- |
* | "Copy your key now, it won't be shown again." |
*
* @param {Settings_Apikeys_Created_WarningInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_created_warning = /** @type {((inputs?: Settings_Apikeys_Created_WarningInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Created_WarningInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_created_warning(inputs)
});
export { settings_apikeys_created_warning as "settings.apikeys.created_warning" }